var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "submit-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "field-block" }, [
        _c("label", { staticClass: "block-label" }, [
          _vm._v(_vm._s(_vm.$t("support_form_type_label"))),
        ]),
        _c(
          "div",
          { staticClass: "type-grid" },
          _vm._l(_vm.typeOptions, function (opt) {
            return _c(
              "button",
              {
                key: opt.value,
                staticClass: "category-button",
                class: { active: _vm.form.type === opt.value },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.form.type = opt.value
                  },
                },
              },
              [
                _c("i", [_vm._v(_vm._s(_vm.typeCode(opt)))]),
                _c("span", [
                  _c("strong", [_vm._v(_vm._s(_vm.typeLabel(opt)))]),
                  _c("small", [_vm._v(_vm._s(_vm.typeHint(opt)))]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "field-block message-field" },
        [
          _c("div", { staticClass: "field-label-row" }, [
            _c("label", { staticClass: "block-label" }, [
              _vm._v(_vm._s(_vm.$t("support_form_desc_label"))),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.descLength) + "/600")]),
          ]),
          _c("el-input", {
            staticClass: "message-input",
            attrs: {
              type: "textarea",
              maxlength: "600",
              rows: 5,
              placeholder: _vm.$t("support_form_desc_placeholder"),
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "field-block upload-field" }, [
        _c("div", { staticClass: "field-label-row" }, [
          _c("label", { staticClass: "block-label" }, [
            _vm._v(_vm._s(_vm.$t("support_form_upload_label"))),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("support_form_upload_tips")))]),
        ]),
        _c(
          "div",
          { staticClass: "upload-strip" },
          [
            _c(
              "el-upload",
              {
                staticClass: "upload-tile",
                attrs: {
                  multiple: "",
                  limit: 5,
                  "file-list": _vm.fileList,
                  "auto-upload": false,
                  "show-file-list": false,
                  "on-change": _vm.handleFileChange,
                  "on-remove": _vm.handleFileRemove,
                  "before-upload": _vm.beforeUpload,
                  action: "/",
                  "http-request": _vm.noopRequest,
                },
              },
              [
                _c("span", {
                  staticClass: "image-icon",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("support_form_upload_click"))),
                ]),
              ]
            ),
            _vm.fileList.length
              ? _c(
                  "div",
                  { staticClass: "attachment-list" },
                  _vm._l(_vm.fileList, function (file) {
                    return _c(
                      "div",
                      {
                        key: file.uid || file.name,
                        staticClass: "attachment-card",
                        class: { uploading: file.__uploading },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.getFileThumbUrl(file),
                            alt: _vm.$t("support_attachment_preview"),
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "remove-attachment",
                            attrs: {
                              type: "button",
                              "aria-label": _vm.$t("support_remove_attachment"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeFile(file)
                              },
                            },
                          },
                          [_vm._v("×")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "form-actions" }, [
        _c(
          "button",
          {
            staticClass: "ghost-button",
            attrs: { type: "button" },
            on: { click: _vm.resetForm },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("cancel_text")) + "\n    ")]
        ),
        _c(
          "button",
          { staticClass: "primary-button", attrs: { type: "submit" } },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("support_form_submit")) + "\n    "
            ),
          ]
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            "append-to-body": "",
            width: _vm.isMobile ? "100%" : "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-container" }, [
            _vm.previewSrc
              ? _c("img", {
                  staticClass: "preview-image",
                  attrs: {
                    src: _vm.previewSrc,
                    alt: _vm.$t("support_attachment_preview"),
                  },
                })
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }